import React from "react";
import B2BCarousel2 from "../components/b2bcomponents/B2BCarousel2";
import B2Bfounders from "../components/b2bcomponents/b2bfounders";
import B2BSection_1 from "../components/b2bcomponents/b2bSection_1";
import B2BTraining from "../components/b2bcomponents/B2BTraining";
import B2BTraining_Sec from "../components/b2bcomponents/B2BTraining_Sec";
import B2BTestimonials from "../components/b2bcomponents/b2bTestimonials";
import Footer from "../components/Footer";
import B2bNavbar from "../components/b2bcomponents/b2bNavbar";
import B2BTest from "../components/b2bcomponents/B2BTest";
import BookSessions from "../components/b2bcomponents/bookSessions";
import ClientCarousel from "../components/b2bcomponents/ClientCarousel";
const b2bHome = () => {
	return (
		<>
			<B2bNavbar />
			<B2BTest />
			<B2BTraining_Sec />
			<B2BCarousel2 />
			<B2BSection_1 />
			<ClientCarousel />
			<B2BTestimonials />
			<B2BTraining />
			<B2Bfounders />
			<BookSessions />
			<Footer />
		</>
	);
};

export default b2bHome;
